import { useState } from 'react';
import { Breadcrumbs, ContentLayout } from 'components/Layout';
import { ForbiddenFallback } from 'components/Elements';
import { Authorization, ROLES } from 'lib/authorization';
import { motion } from 'framer-motion';
import { FiMail, FiToggleLeft, FiToggleRight, FiFolder } from 'react-icons/fi';

export const VaultTransferSettings = () => {
  const [emailTransfersEnabled, setEmailTransfersEnabled] = useState(true);
  const [vaultSelectorVisible, setVaultSelectorVisible] = useState(true);

  return (
    <Authorization
      allowedRoles={[
        ROLES.ROOT_USER,
        ROLES.TRANSACTION_MANAGER,
        ROLES.TECHNICAL,
        ROLES.CUSTOMER_SUPPORT,
      ]}
      forbiddenFallback={<ForbiddenFallback />}
    >
      <ContentLayout title="Vault Transfer Settings" breadcrumbs={<Breadcrumbs />}>
        <div className="flex flex-col gap-6 w-full">
          <h2 className="text-xl text-white font-semibold">Transfer Behavior</h2>

          {/* Toggle Email-Based Transfers */}
          <motion.div
            whileHover={{ scale: 1.01 }}
            className="flex items-center justify-between p-4 rounded-xl bg-white/5 backdrop-blur-md border border-white/10"
          >
            <div className="flex items-center gap-3">
              <div className="w-10 h-10 rounded-full bg-white/10 flex items-center justify-center">
                <FiMail className="text-white text-xl" />
              </div>
              <div>
                <p className="text-white font-medium">Enable Email-Based Transfers</p>
                <p className="text-sm text-white/50">Allow transfers using user emails.</p>
              </div>
            </div>
            <button
              onClick={() => setEmailTransfersEnabled((prev) => !prev)}
              className="text-white text-2xl"
            >
              {emailTransfersEnabled ? <FiToggleRight /> : <FiToggleLeft />}
            </button>
          </motion.div>

          {/* Toggle Vault Selector Visibility */}
          <motion.div
            whileHover={{ scale: 1.01 }}
            className="flex items-center justify-between p-4 rounded-xl bg-white/5 backdrop-blur-md border border-white/10"
          >
            <div className="flex items-center gap-3">
              <div className="w-10 h-10 rounded-full bg-white/10 flex items-center justify-center">
                <FiFolder className="text-white text-xl" />
              </div>
              <div>
                <p className="text-white font-medium">Show Vault Selector</p>
                <p className="text-sm text-white/50">Display vault selector during transfers.</p>
              </div>
            </div>
            <button
              onClick={() => setVaultSelectorVisible((prev) => !prev)}
              className="text-white text-2xl"
            >
              {vaultSelectorVisible ? <FiToggleRight /> : <FiToggleLeft />}
            </button>
          </motion.div>
        </div>
      </ContentLayout>
    </Authorization>
  );
};
